/// <amd-module name="TFS/Admin/Views/OrganizationProjects/Contracts/DataModels" />
import { TeamProjectReference, ProjectState } from "Tfs/Platform/Contracts/Core";
import { ISearchResultCache } from "TFS/Admin/Groups/Common/Contracts";

export namespace OrganizationProjectsConstants {
    export const ProgressPollInterval = 500;
    export const UpdateCheckCount = 1000;
    export const RestOperationClient = "IOperationsRestClient";
    export const RestCoreClient = "ICoreRestClient";
    export const ContributionService = "ms.vss-admin-web.organization-projects-data-provider";
    export const UrlRouterService = "ms.vss-work-web.work-customization-route";
    export const routerWorkItem = "workitemtypes";
}

export namespace OpConstants {
    export const IDLE = "idle";
    export const RENAME = "rename";
    export const DELETE = "delete";
    export const MULTIDELETE = "multidelete";
    export const ADD = "add";
    export const MULTIRESTORE = "multirestore";
}

export type Operations =
    | typeof OpConstants.IDLE
    | typeof OpConstants.RENAME
    | typeof OpConstants.DELETE
    | typeof OpConstants.ADD
    | typeof OpConstants.MULTIDELETE
    | typeof OpConstants.MULTIRESTORE;

export interface IUpdateProjectNode {
    state?: ProjectState;
    name?: string;
}

export interface IOrganizationProjectsData {
    projects: [IOrganizationProjectInfo];
    deletedProjects: [IOrganizationProjectInfo];
}

export interface OperationPair {
    projectName: string;
    projectId: string;
    operationId: string;
}

export interface IOrganizationProjectInfo {
    projectId: string;
    hasDeletePermission: boolean;
    hasRenamePermission: boolean;
    processTemplateName: string;
    teamProjectReference: TeamProjectReference;
}

export interface OrganizationProjectReference extends TeamProjectReference {
    hasDeletePermission?: boolean;
    hasRenamePermission?: boolean;
    processTemplateName?: string;
}

export interface IOrganizationProjectsComponentState {
    projects: OrganizationProjectReference[];
    softDeletedProjects: OrganizationProjectReference[];
    currentOperation: Operations;
    error: string;
    isInProgress: boolean;
    showErrorMessage: boolean;
    showRestoreDialog: boolean;
    searchResult: ISearchResultCache;
}
